export enum Privileges {
  ADMIN = 'ADMIN',
  SUPER_AGENT = 'SUPER_AGENT',
  NON_ADMIN = 'NON_ADMIN',
}
